import { motion } from "framer-motion";
import { useState } from "react";
import { FaFacebookF, FaInstagram, FaWhatsapp } from "react-icons/fa";
export default function ContactForm() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  if (loading) return;

  setLoading(true);

  try {
    const res = await fetch("https://api.solidera-energy.com/send-mail.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    const text = await res.text(); // 👈 SAFE

    let data;
    try {
      data = JSON.parse(text); // 👈 TRY PARSE
    } catch {
      throw new Error("Invalid JSON from server");
    }

    if (data.status === "success") {
      setSubmitted(true);
      setFormData({
        name: "",
        email: "",
        phone: "",
        message: "",
      });

      setTimeout(() => setSubmitted(false), 3000);
    } else {
      alert("❌ Failed: " + (data.message || "Unknown error"));
    }
  } catch (err) {
    console.error(err);
    alert("⚠️ Server error (check API response)");
  } finally {
    setLoading(false);
  }
};
  const contactMethods = [
    { icon: "📞", title: "PHONE", value: "03337111075" },
    { icon: "📧", title: "MAIL", value: "info@solidera-energy.com" },
    { icon: "🌐", title: "WEBSITE", value: "www.solidera-energy.com" },
    { icon: "⏰", title: "HOURS", value: "9 AM - 6 PM, Mon-Sat" },
  ];

  return (
    <section
      id="contact"
      className="relative py-20 px-6 text-white"
      style={{
        backgroundImage: `linear-gradient(135deg, rgba(0,0,0,0.85), rgba(249,122,8,0.25)), url('/assets/s1.jpg')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
      }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/40 backdrop-blur-md"></div>

      <div className="relative z-10 max-w-7xl mx-auto">
        {/* HEADER */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-orange-400 mb-4">
            Get In Touch
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-orange-400 to-yellow-400 mx-auto mb-4" />
          <p className="text-white/70 max-w-2xl mx-auto">
            Have questions? Contact us for solar consultation and solutions.
          </p>
        </motion.div>

        {/* GRID */}
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          
          {/* LEFT SIDE */}
          <div className="space-y-6">
            {contactMethods.map((method, index) => (
              <motion.div
                key={index}
                whileHover={{ scale: 1.03 }}
                className="p-6 rounded-xl bg-black/40 backdrop-blur-lg border border-orange-500/20 hover:border-orange-500/50 transition-all"
              >
                <div className="flex gap-4 items-start">
                  <span className="text-3xl">{method.icon}</span>
                  <div>
                    <h3 className="text-white font-semibold mb-1">
                      {method.title}
                    </h3>
                    <p className="text-white/60">{method.value}</p>
                  </div>
                </div>
              </motion.div>
            ))}

            {/* SOCIAL */}
           {/* SOCIAL */}
<div>
  <p className="text-white font-semibold mb-4">Follow Us</p>

  <div className="flex gap-4">

    {/* Facebook */}
    <motion.a
      href="https://www.facebook.com/profile.php?id=61574004411820"
      target="_blank"
      rel="noopener noreferrer"
      whileHover={{ scale: 1.2 }}
      className="w-12 h-12 rounded-full bg-orange-500/20 border border-orange-500/50 flex items-center justify-center text-orange-400 hover:bg-orange-500/40 transition"
    >
      <FaFacebookF />
    </motion.a>

    {/* Instagram */}
    <motion.a
      href="https://www.instagram.com/solid_era_energy/"
      target="_blank"
      rel="noopener noreferrer"
      whileHover={{ scale: 1.2 }}
      className="w-12 h-12 rounded-full bg-orange-500/20 border border-orange-500/50 flex items-center justify-center text-orange-400 hover:bg-orange-500/40 transition"
    >
      <FaInstagram />
    </motion.a>

    {/* WhatsApp */}
    <motion.a
      href="https://wa.me/923337111075"
      target="_blank"
      rel="noopener noreferrer"
      whileHover={{ scale: 1.2 }}
      className="w-12 h-12 rounded-full bg-green-500/20 border border-green-500/50 flex items-center justify-center text-green-400 hover:bg-green-500/40 transition"
    >
      <FaWhatsapp />
    </motion.a>

  </div>
</div>
          </div>

          {/* RIGHT SIDE FORM */}
          <motion.form
            onSubmit={handleSubmit}
            className="space-y-4 bg-black/40 backdrop-blur-xl p-6 rounded-xl border border-orange-500/20"
          >
            {["name", "email", "phone"].map((field) => (
              <div key={field}>
                <label className="block mb-2 capitalize">{field}</label>
                <input
                  type={field === "email" ? "email" : "text"}
                  name={field}
                  value={formData[field]}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 bg-black/50 border border-orange-500/30 rounded-lg text-white focus:border-orange-500 outline-none"
                />
              </div>
            ))}

            <div>
              <label className="block mb-2">Message</label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                rows="4"
                required
                className="w-full px-4 py-3 bg-black/50 border border-orange-500/30 rounded-lg text-white outline-none"
              />
            </div>

            {/* BUTTON */}
            <button
              disabled={loading}
              className="w-full py-3 bg-gradient-to-r from-orange-400 to-orange-600 text-black font-bold rounded-lg hover:shadow-xl disabled:opacity-50 transition"
            >
              {loading ? "Sending..." : submitted ? "✓ Sent" : "Send Message"}
            </button>

            {/* SUCCESS MESSAGE */}
            {submitted && (
              <p className="text-green-400 text-center animate-pulse">
                ✅ Message sent successfully!
              </p>
            )}
          </motion.form>
        </div>
      </div>
    </section>
  );
}